/**
 * 🤖 AUTO-GENERATED API SCHEMA FILE - DO NOT EDIT DIRECTLY!
 *
 * This file is automatically generated from entity configuration files.
 * Any manual changes will be lost when the generator runs again.
 *
 * 🔄 DATA FLOW PIPELINE:
 * 1. Entity Config (config/entities/property_files-entity-config.ts) → Single Source of Truth
 * 2. THIS FILE → TypeBox schemas for runtime validation + API types
 * 3. API Clients → Use these schemas for request/response validation
 * 4. React Hooks → Use these types for type-safe data fetching
 * 5. Components → Import types from this schema file
 *
 * 🛠️ TO MODIFY:
 * - Edit the entity config file: config/entities/property_files-entity-config.ts
 * - Run: npm run schemas:gen (regenerates this file)
 *
 * 📋 ARCHITECTURE:
 * - Entity configs define field publicity, types, and validation rules
 * - TypeBox schemas provide runtime validation for API requests/responses
 * - Static types are derived from TypeBox schemas for compile-time safety
 * - Query options and response types standardize API interactions
 *
 * 🔗 RELATED FILES:
 * - config/entities/property_files-entity-config.ts (source configuration)
 * - scripts/generate-api-clients.ts (this generator)
 * - client/api/generated_clients/generated-property_files-api-client.ts (API client using these schemas)
 * - client/api/generated_hooks/property_files.ts (React hooks using these types)
 *
 * 🔒 SECURITY: Only fields marked as 'public: true' in the config are included
 *
 * Source config: config/entities/property_files-entity-config.ts
 * Public fields: 15/15 total fields
 */

import { Type, Static } from '@sinclair/typebox';


// TypeBox schemas for runtime validation (public fields only)
export const PropertyFilesSchema = Type.Object({
  id: Type.String({ format: "uuid" }), // id field
  property_id: Type.Union([Type.String({ format: "uuid" }), Type.Null()]), // property_id field
  data_source_id: Type.Union([Type.String({ format: "uuid" }), Type.Null()]), // data_source_id field
  file_name: Type.Union([Type.String(), Type.Null()]), // file_name field
  mime_type: Type.Union([Type.String(), Type.Null()]), // mime_type field
  storage_key: Type.Union([Type.String(), Type.Null()]), // storage_key field
  file_url: Type.Union([Type.String(), Type.Null()]), // file_url field
  description: Type.Union([Type.String(), Type.Null()]), // description field
  uploaded_by_user_profile_id: Type.Union([Type.String({ format: "uuid" }), Type.Null()]), // uploaded_by_user_profile_id field
  created_at: Type.Union([Type.String({ format: "date-time" }), Type.Null()]), // created_at field
  updated_at: Type.String({ format: "date-time" }), // updated_at field
  archived_at: Type.Union([Type.String({ format: "date-time" }), Type.Null()]), // archived_at field
  archived_by_user_profile_id: Type.Union([Type.String({ format: "uuid" }), Type.Null()]), // archived_by_user_profile_id field
  archive_reason: Type.Union([Type.String(), Type.Null()]), // archive_reason field
  archive_batch_id: Type.Union([Type.String({ format: "uuid" }), Type.Null()]), // archive_batch_id field
});

export const CreatePropertyFilesSchema = Type.Object({
  property_id: Type.Optional(Type.Union([Type.String({ format: "uuid" }), Type.Null()])), // property_id field
  data_source_id: Type.Optional(Type.Union([Type.String({ format: "uuid" }), Type.Null()])), // data_source_id field
  file_name: Type.Optional(Type.Union([Type.String(), Type.Null()])), // file_name field
  mime_type: Type.Optional(Type.Union([Type.String(), Type.Null()])), // mime_type field
  storage_key: Type.Optional(Type.Union([Type.String(), Type.Null()])), // storage_key field
  file_url: Type.Optional(Type.Union([Type.String(), Type.Null()])), // file_url field
  description: Type.Optional(Type.Union([Type.String(), Type.Null()])), // description field
  uploaded_by_user_profile_id: Type.Optional(Type.Union([Type.String({ format: "uuid" }), Type.Null()])), // uploaded_by_user_profile_id field
  archived_at: Type.Optional(Type.Union([Type.String({ format: "date-time" }), Type.Null()])), // archived_at field
  archived_by_user_profile_id: Type.Optional(Type.Union([Type.String({ format: "uuid" }), Type.Null()])), // archived_by_user_profile_id field
  archive_reason: Type.Optional(Type.Union([Type.String(), Type.Null()])), // archive_reason field
  archive_batch_id: Type.Optional(Type.Union([Type.String({ format: "uuid" }), Type.Null()])), // archive_batch_id field
});

export const UpdatePropertyFilesSchema = Type.Object({
  property_id: Type.Optional(Type.Union([Type.String({ format: "uuid" }), Type.Null()])), // property_id field
  data_source_id: Type.Optional(Type.Union([Type.String({ format: "uuid" }), Type.Null()])), // data_source_id field
  file_name: Type.Optional(Type.Union([Type.String(), Type.Null()])), // file_name field
  mime_type: Type.Optional(Type.Union([Type.String(), Type.Null()])), // mime_type field
  storage_key: Type.Optional(Type.Union([Type.String(), Type.Null()])), // storage_key field
  file_url: Type.Optional(Type.Union([Type.String(), Type.Null()])), // file_url field
  description: Type.Optional(Type.Union([Type.String(), Type.Null()])), // description field
  uploaded_by_user_profile_id: Type.Optional(Type.Union([Type.String({ format: "uuid" }), Type.Null()])), // uploaded_by_user_profile_id field
  archived_at: Type.Optional(Type.Union([Type.String({ format: "date-time" }), Type.Null()])), // archived_at field
  archived_by_user_profile_id: Type.Optional(Type.Union([Type.String({ format: "uuid" }), Type.Null()])), // archived_by_user_profile_id field
  archive_reason: Type.Optional(Type.Union([Type.String(), Type.Null()])), // archive_reason field
  archive_batch_id: Type.Optional(Type.Union([Type.String({ format: "uuid" }), Type.Null()])), // archive_batch_id field
});

// TypeScript types derived from TypeBox schemas (matching server-side pattern)
export type PropertyFilesRow = Static<typeof PropertyFilesSchema>;
export type PropertyFilesInsert = Static<typeof CreatePropertyFilesSchema>;
export type PropertyFilesUpdate = Static<typeof UpdatePropertyFilesSchema>;

// Legacy type aliases for backward compatibility
export type PropertyFiles = PropertyFilesRow;
export type CreatePropertyFiles = PropertyFilesInsert;
export type UpdatePropertyFiles = Static<typeof UpdatePropertyFilesSchema>;

// Field configuration metadata
export const PropertyFilesFieldConfig = {
  filterable: ['id', 'property_id', 'data_source_id', 'uploaded_by_user_profile_id', 'archived_by_user_profile_id', 'archive_batch_id'] as const,
  sortable: ['created_at', 'updated_at'] as const,
  searchable: [] as const,
  required: ['id', 'updated_at'] as const,
  readonly: ['id', 'created_at', 'updated_at'] as const,
} as const;

// Query options interface for API operations
import type { UnifiedQueryOptions } from '../../config/search/global-search-config.js';

export interface PropertyFilesQueryOptions extends UnifiedQueryOptions {}

// Response types for API operations
export interface PropertyFilesResponse {
  data: PropertyFiles[] | null;
  error: Error | null;
  count?: number;
}

export interface SinglePropertyFilesResponse {
  data: PropertyFiles | null;
  error: Error | null;
}
